// extracted by mini-css-extract-plugin
export var actions = "_4x-0";
export var actionsContainer = "_4x-7";
export var border = "_4x-1";
export var childFullHeight = "_4x-f";
export var collapse = "_4x-2";
export var content = "_4x-a";
export var contentChild = "_4x-e";
export var fullscreen = "_4x-c";
export var hasLeftRadius = "_4x-k";
export var headerContainer = "_4x-3";
export var headerRow = "_4x-5";
export var hidePadding = "_4x-b";
export var navCollapsedGap = "_4x-l";
export var noScrollX = "_4x-m";
export var noScrollY = "_4x-n";
export var noTopPadding = "_4x-i";
export var optOutTopPadding = "_4x-d";
export var pageMain = "_4x-j";
export var pageOuter = "_4x-g";
export var pagePadding = "_4x-8";
export var pageScroll = "_4x-9";
export var profile = "_4x-o";
export var profileContainer = "_4x-p";
export var profileImage = "_4x-q";
export var profileMain = "_4x-r";
export var profileSubtitle = "_4x-t";
export var profileTitle = "_4x-s";
export var showLeftPadding = "_4x-h";
export var tabsPortalSlot = "_4x-6";
export var tabsWrapper = "_4x-4";
export var title = "_4x-u";